import React from 'react';
import { useTranslate } from '../../../components/TranslationText';
import TranslationsKeys from '../../../TranslationsKeys';

/**
 * Header banner component for Saddle Making Workshop.
 */
export default function WorkshopRegistrationHeader() {
    const { translate } = useTranslate();

    return (
        <div className="p-main bg-white border-15 p-4 mb-main">
            <div className="d-flex align-items-center gap-2 mb-2">
                <i className="fa-solid fa-graduation-cap color-eahsred"></i>
                <span className="color-eahsred fw-bold text-uppercase" style={{ fontSize: 13 }}>
                    {translate(TranslationsKeys.WORKSHOP, 'Workshop Registration')}
                </span>
            </div>

            <h2 className="fw-bold mb-2">
                {translate(TranslationsKeys.SADDLE_WORKSHOP, 'Saddle Making Workshop')}
            </h2>

            <p className="horseCardDescription text-muted mb-0">
                {translate(
                    TranslationsKeys.SADDLE_WORKSHOP_SUBTITLE, 'Please complete the form below to register for the Saddle Making Workshop'
                )}
            </p>
        </div>
    );
}
